// extracted by mini-css-extract-plugin
export default {"addAudienceButton":"AudienceDetails_addAudienceButton__xmw9G"};